export const SEND_DOCUMENTS_ERROR = 'documents/SEND_DOCUMENTS_ERROR';
export const SEND_DOCUMENTS_FETCH = 'documents/SEND_DOCUMENTS_FETCH';
export const SEND_DOCUMENTS_DATA = 'documents/SEND_DOCUMENTS_DATA';
